import { createContext } from './selectableContext';

export const KeyContext = createContext({
  myState: {},
  theme: {},
  helpers: {}
});
